import { getCurrentDictionaryLabel } from '../currentDictionary.service';
function sendAnalyticsEvent(event) {
    const windowAsAny = window;
    if (!windowAsAny.gtag) {
        if (windowAsAny.ga) {
            windowAsAny.ga('send', 'event', event.category, event.action, event.label, event.value);
        }
        else {
            console.warn("Neither ga nor gtag is available");
        }
        return;
    }
    const gtag = windowAsAny.gtag;
    gtag('event', event.action, {
        'event_category': event.category,
        'event_label': event.label,
        'event_value': event.value,
    });
}
export function sendCurrentDictionaryAnalyticsEvent(event) {
    sendAnalyticsEvent(Object.assign(Object.assign({}, event), { category: getCurrentDictionaryLabel() + (event.category || '') }));
}
export function sendUIInteractionAnalyticsEvent(event) {
    sendAnalyticsEvent(Object.assign(Object.assign({}, event), { category: "interface" }));
}
export function sendFavoriteAnalyticsEvent(event) {
    sendAnalyticsEvent(Object.assign(Object.assign({}, event), { category: "favorite" }));
}
